import BasicModal from 'components/shared/BasicModal';
import InspectorForm from 'src/pages/authentication/components/inspectorAccount/InspectorForm';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Box, Button, Typography } from '@mui/material';
import createUpdateInspectorAccount from 'src/api/createUpdateInspectorAccount';

const InspectorModal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [isSent, setIsSent] = useState<boolean>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (): void => {
    setOpen(false);
    setIsSent(false);
  };

  const { mutate, isPending } = useMutation({
    mutationFn: (email: string) => createUpdateInspectorAccount(email, true),
    onSuccess: () => {
      setIsSent(true);
    },
    onError: (error) => {
      console.error('Error al enviar la nueva contraseña:', error);
    },
  });

  const handleSendPassword = (email: string) => () => {
    mutate(email);
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="outlined"
        color="primary"
        size="large"
        sx={{
          width: '90%',
          marginInline: 'auto',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '@media screen and (max-width: 330px)': {
            fontSize: '12px',
          },
          '&:hover': {
            color: '#0093b3',
            transition: 'all 0.3s ease',
          },
        }}
      >
        Solicitar Clave
      </Button>

      {open && (
        <BasicModal
          open={open}
          handleClose={handleClose}
        >
          {isSent ? (
            <Typography
              color="textPrimary"
              variant="body1"
              sx={{ marginTop: 4, marginX: 'auto', textAlign: 'center' }}
            >
              Su nueva contraseña ha sido enviada a su correo electrónico.
            </Typography>
          ) : (
            <InspectorForm
              resetPassword={(email, expirationDate) => (
                <>
                  <Typography component="div">
                    <Typography
                      color="textPrimary"
                      variant="h4"
                      marginBottom={5}
                    >
                      Contraseña Activa
                    </Typography>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                      marginTop={2}
                      marginX="auto"
                    >
                      Su contraseña actual se encuentra activa hasta el día
                      <span
                        style={{
                          fontWeight: 500,
                          display: 'inline-block',
                          paddingLeft: '5px',
                        }}
                      >
                        {expirationDate}
                      </span>
                    </Typography>
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    marginY={2}
                    marginX="auto"
                    textAlign="center"
                    fontWeight={500}
                  >
                    ¿Desea recibir una nueva contraseña a su correo electrónico?
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '10px',
                    }}
                  >
                    <Button
                      id="cancel-button"
                      color="error"
                      fullWidth
                      size="large"
                      type="button"
                      variant="outlined"
                      onClick={handleClose}
                      disabled={isPending}
                    >
                      Cancelar
                    </Button>
                    <Button
                      id="send-password-button"
                      color="primary"
                      fullWidth
                      size="large"
                      onClick={handleSendPassword(email)}
                      disabled={isPending}
                      variant="contained"
                    >
                      {isPending ? 'Enviando...' : 'Enviar'}
                    </Button>
                  </Box>
                </>
              )}
            />
          )}
        </BasicModal>
      )}
    </>
  );
};

export default InspectorModal;
